export default {
  'action.ok': '确认',
  'action.cancel': '取消',
  'action.create': '创建',
  'action.add': '添加',
  'action.edit': '编辑',
  'action.delete': '删除',
  'action.modify': '保存修改',
  'action.backHome': '返回首页',
  'action.back': '返回',
  'action.activate': '激活',
  'action.deactivate': '冻结',
  'action.save': '保存',
  'action.unsave': '不保存',
  'action.switch': '分配',
  'action.update': '更新',
  'action.reset': '重置',
  'action.confirm': '确认',
  'action.export': '导出',
  'action.exporting': '正在导出',
  'action.refresh': '刷新',
  'action.fastCopy': '快速复制',
  'action.refund': '退款',
  'action.viewReceipt': '查看收据',
  'action.viewSetting': '查看设置',
  'action.next': '下一步',
  'action.apply': '应用',
  'action.download': '下载',
  'action.exit': '退出',
  'action.selectMultiple': '多选',
  'action.changeColor': '更换颜色',
  'action.send.receipt': '发送收据',
  'action.send.text.receipt': '发送短信收据',
  'action.send.email.receipt': '发送邮件收据',
  'action.send.receipt.cancel': '取消',
  'action.send.receipt.send': '发送',
  'action.clear': '清空',
  'action.clearAll': '清空所有',
  'action.addRule': '添加规则',
  'action.submit': '提交',
  'action.addBreak': '新增休息记录',
  'action.close': '关闭',
  'action.connect': '链接',
  'action.deletePolicy': '删除方案',
  'action.retry': '重试',
  'action.addMemberPrice': '添加会员价',
  'action.activateRestaurant': '激活餐厅',
  'action.addPointPrice': '添加积分价',
  'action.scan': '绑定',
  'action.rescan': '重新绑定',
  'action.generate': '生成',
  'action.regenerate': '重新生成',
  'action.preview': '预览',
  'action.upload': '上传',
  'action.resetLoginPassword': '重设登录密码',
  'action.sort': '排序',
  'action.done': '完成',
  'action.modifyName': '修改名称',
  'action.retain': '保留',
  'action.notRetain': '不保留',
  'action.search': '搜索',
  'action.multiple': '多选',
  'action.addTo': '添加到',
  'action.removeFrom': '从中删除',
  'action.selectAll': '全选',
  'action.publish': '发布',
  'action.duplicate': '复制',
  'action.finish': '完成',
};
